import { kcDcmTokenApi } from '@custom/rtk-apis/authentication/kc-dcm-token';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const kcDcmTokenSlice = createSlice({
  name: 'kcDcmToken',
  initialState,
  reducers: {
    clearkcDcmTokenState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(kcDcmTokenApi.pending, (state, action) => {
        state.status = 'LOADING';
        state.loading = true;
        state.msg = 'LOADING...';
      })
      .addCase(kcDcmTokenApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = 'PACS authenticated successfully.';
      })
      .addCase(kcDcmTokenApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = '';
        state.msg = action?.payload || 'Something went wrong!';
      });
  },
});

export default kcDcmTokenSlice.reducer;
export const { clearkcDcmTokenState } = kcDcmTokenSlice.actions;
